<template>
    <admin-page :result="result" description="Marca el email como verificado en Firebase Auth">
        <div class="form-row">
            <kimsa-text-field class="form-field" @change="email = $event" :value="email" label="Email del usuario"
                placeholder="usuario@correo.com" dense hide-details />
            <v-btn color="primary" class="black--text form-btn" depressed :loading="loading" :disabled="!email"
                @click="confirmEmail">
                Confirmar
            </v-btn>
        </div>
    </admin-page>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import KimsaTextField from '@/components/common/inputs/KimsaTextField.vue'
import AdminPage from '@/components/admin/AdminPage.vue'
import { adminRouteGuard } from '@/utils/Admin'

export default {
    name: 'AdminConfirmEmail',
    components: { KimsaTextField, AdminPage },
    beforeRouteEnter: adminRouteGuard,
    data() {
        return {
            email: '',
            loading: false,
            result: null,
        }
    },
    mounted() {
        const vm = this
        if (vm.$route.query.email) vm.email = vm.$route.query.email
    },
    methods: {
        async confirmEmail() {
            const vm = this
            vm.loading = true
            vm.result = null
            try {
                const fn = firebase.functions().httpsCallable('httpAdmin-confirmEmail')
                const { data } = await fn({ email: vm.email.trim() })
                vm.result = {
                    type: 'success',
                    message: data.alreadyVerified
                        ? `El email ${vm.email} ya estaba verificado (uid ${data.uid}).`
                        : `Email ${vm.email} marcado como verificado (uid ${data.uid}).`
                }
                vm.email = ''
            } catch (err) {
                console.error('[adminConfirmEmail] error', err)
                vm.result = {
                    type: 'error',
                    message: err.message || 'Error al confirmar el email.'
                }
            } finally {
                vm.loading = false
            }
        },
    },
}
</script>

<style scoped>
.form-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}

.form-field {
    flex: 1;
    min-width: 240px;
}

.form-btn {
    height: 40px !important;
    min-width: 140px;
    border-radius: 8px;
}

@media (max-width: 600px) {
    .form-btn {
        width: 100%;
    }
}
</style>
